import { render, staticRenderFns } from "./indicadorArea.vue?vue&type=template&id=1785378c&scoped=true&"
import script from "./indicadorArea.vue?vue&type=script&lang=ts&"
export * from "./indicadorArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785378c",
  null
  
)

export default component.exports